import styled from 'styled-components';
import { getShorthandActionColor, getThemeColor } from 'utils/styled';
import { StatusTagStyleProps } from './types';

export const Root = styled.div<StatusTagStyleProps>`
  ${({ theme }) => theme.typography.variants.label.default};

  background-color: ${({ $color }) => getShorthandActionColor($color)};

  border-radius: 4px;
  color: ${getThemeColor('white')};
  line-height: 1.33;
  padding: 3px 6px;
`;
